import { render } from "./ArticlesSection.vue?vue&type=template&id=372dfdd7&scoped=true"
import script from "./ArticlesSection.vue?vue&type=script&lang=js"
export * from "./ArticlesSection.vue?vue&type=script&lang=js"

import "./ArticlesSection.vue?vue&type=style&index=0&id=372dfdd7&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372dfdd7"]])

export default __exports__